import Vue from 'vue'
import axios from 'axios'
import Constants from './constants'
import {FORBIDDEN, UNAUTHORIZED} from 'http-status-codes'

export function get(url, headers) {
  return request(url, headers, null, 'get')
}

export function post(url, headers, data) {
  return request(url, headers, data, 'post')
}

export function put(url, headers, data) {
  return request(url, headers, data, 'put')
}

export function patch(url, headers, data) {
  return request(url, headers, data, 'patch')
}

export function del(url, headers) {
  return request(url, headers, null, 'delete')
}

export function downloadGet(url, headers) {
  return request(url, headers, null, 'get', 'arraybuffer')
}

export function downloadPost(url, headers, data) {
  return request(url, headers, data, 'post', 'arraybuffer')
}

async function request(url, headers, data, method, responseType = 'json') {
  const config = {
    url,
    method,
    headers,
    responseType,
    data: null
  }

  if (data) {
    config.data = data
  }

  let response = {}

  try {
    Vue.$log.debug('Axios Request', config)
    response = await axios(config)
    Vue.$log.debug('Axios Response', JSON.parse(JSON.stringify(response)))
  } catch (e) {
    console.log('Axios Error - URL', url)

    const error = {
      title: 'API Error',
      type: Constants.ERROR_TYPES.AXIOS,
      details: {}
    }

    if (e.response) {
      if (UNAUTHORIZED === e.response.status || FORBIDDEN === e.response.status) {
        Vue.prototype.$eventHub.$emit('api-40x-unauthorized', error)
      }

      // The request was made and the server responded with a status code
      // that falls out of the range of 2xx
      console.log('e.response', e.response)
      console.log('Response data', e.response.data);
      console.log('Response status', e.response.status);
      error.details = e.response

      response = e.response
    } else if (e.request) {
      console.log('NO RESPONSE', JSON.parse(JSON.stringify(e)))
      // The request was made but no response was received
      // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
      // http.ClientRequest in node.js
      console.log('Request', e.request);
    } else {
      // Something happened in setting up the request that triggered an Error
      console.log('Error', e.message);
      response.status = 500
      response.statusText = e.message
    }

    if (Vue.$eventHub) {
      Vue.$eventHub.$emit('error', error)
    }
  }

  if (response.data && response.data.errors) {
    response.errors = response.data.errors
  }

  return response
}
